const ContactUsRepository = (Fw5MLApi, ContactUsParser) => ({
  async sendMessage({ deviceId = null, user, ...payload }) {
    const device = {}
    // Attach deviceId if exists otherwise attach blackbox
    device.device_id = deviceId ? `${deviceId}` : null
    const url = user?.premiumAccountConsultant?.active
      ? `/contact/premium`
      : `/contact`
    const req = await Fw5MLApi.fetch(url, 'POST', {
      device,
      ...payload
    })
    return req?.data
  },

  async sendZohoRequest(payload) {
    const { isFeatureEnabled = false } = payload
    try {
      let req
      if (!isFeatureEnabled) {
        req = await Fw5MLApi.fetch('/consultant/followup', 'post', payload)
        return req?.data
      }

      const parsed = ContactUsParser.parseZohoDataRequest(payload)
      req = await Fw5MLApi.fetch('/zoho/saveData', 'post', parsed)
      localStorage.removeItem('campaignParams')
      return req?.data
    } catch (error) {
      console.error('Error during parsing or request:', error)
      throw error
    }
  }
})

export default ContactUsRepository
